exports = module.exports = require("./../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "navbar-sub-menu{height:100%}navbar-sub-menu a{outline:none;font-size:0}navbar-sub-menu .wrapper{display:flex;align-items:center;height:100%;color:#e8e8e8}navbar-sub-menu .wrapper>div{flex:1;display:flex;align-items:center;justify-content:center;height:100%;margin:0;text-align:center;text-transform:uppercase;font-size:2.7vmin}navbar-sub-menu .wrapper>div.selected{color:#ffac25;background-color:#0f143a;position:relative}navbar-sub-menu .wrapper>div.selected:after,navbar-sub-menu .wrapper>div.selected:before{content:\" \";position:absolute;border-width:1.8vmin 3vmin;border-color:transparent;border-style:solid}navbar-sub-menu .wrapper>div.selected:before{left:-6vmin;border-right-color:#ffac25}navbar-sub-menu .wrapper>div.selected:after{right:-6vmin;border-left-color:#ffac25}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./client/app/components/common/navbarSubMenu/navbarSubMenu.scss
 ** module id = 150
 ** module chunks = 0
 **/